import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import type { QueryFunctionContext } from '@tanstack/react-query'
import { useInfiniteQuery } from '@tanstack/react-query'

export const useMemberChargesSubscriptionsInfiniteQuery = (memberId: number) => {
  const limit = 20

  const memberChargesSubscriptionsInfiniteQuery = useInfiniteQuery({
    queryKey: ['memberChargesSubscriptionsInfinite', memberId],
    queryFn: async ({ pageParam = 1 }: QueryFunctionContext<any, number>) => {
      const { data } = await MembershipsCreatorApiClient.getMemberChargesSubscriptions(
        { member_id: memberId },
        {
          limit,
          page: pageParam,
        },
      )

      return data
    },
    getNextPageParam: ({ pagination }) => {
      if (pagination?.pages === pagination?.page) return

      return pagination && pagination.page + 1
    },
    cacheTime: 0,
  })

  return { memberChargesSubscriptionsInfiniteQuery }
}
